<template>
  <time :title="actualTime">{{ relativeTime }}</time>
</template>
<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import rt__ from 'bits/relative_time'
import { hyphenatedCurrentLocale } from 'bits/current_locale'

export default {
  props: {
    datetime: {},
    dateformat: {
      default: 'short',
    },
    autoupdate: {
      default: false,
    },
  },
  computed: {
    relativeTime: function() {
      const t = this.datetime
      const f = this.dateformat
      return rt__(t, f)
    },
    actualTime: function() {
      const date = new Date(this.datetime)
      return date.toLocaleString(hyphenatedCurrentLocale)
    },
  },
}
</script>
